// Suspendre / réactiver une carte.
//
// L'état vit dans la propriété Notion « State ». Le libellé exact, émoji
// compris, est la clé : c'est lui que renvoie le webhook `load-all-cards` et
// c'est lui qu'écrivent les workflows n8n J (suspendre) et K (réactiver).
export const SUSPENDED_STATE = '🔶 Suspendu';

// Une carte réactivée repart à « New » : son intervalle et sa date de dernière
// révision sont conservés, elle réapparaît donc à son échéance normale.
export const REACTIVATED_STATE = 'New';

// On teste le mot plutôt que l'égalité stricte : le workflow A2 fait de même
// côté serveur, et une variante d'émoji dans Notion ne doit pas remettre une
// carte suspendue dans la file du jour.
export const isSuspended = (card) =>
  String(card?.state || '').includes('Suspendu');

const API_URL =
  process.env.REACT_APP_N8N_URL || 'https://n8n.automationtekleabsam.com/webhook';

// Les webhooks n8n répondent parfois 200 avec un corps vide. Lire `response.json()`
// levait alors une exception alors que Notion avait bien été mis à jour, et
// l'interface annonçait une erreur pour une opération réussie. C'est donc le
// code HTTP qui fait foi ; le corps n'est lu que s'il est exploitable.
const postPageId = async (path, pageId) => {
  const response = await fetch(`${API_URL}/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pageId }),
  });

  if (!response.ok) {
    throw new Error(`${path} a répondu ${response.status}`);
  }

  const text = await response.text();
  if (!text.trim()) return { success: true };

  try {
    const result = JSON.parse(text);
    if (result && result.success === false) {
      throw new Error(result.message || `${path} a signalé un échec`);
    }
    return result;
  } catch (error) {
    if (error instanceof SyntaxError) return { success: true };
    throw error;
  }
};

export const suspendCard = (pageId) => postPageId('suspend-card', pageId);

export const reactivateCard = (pageId) => postPageId('reactivate-card', pageId);
